import {registerServiceClients} from '@multipass-service-ioc';
import {Container} from 'esp-js-di';

import {FetchServiceImpl, MessagingClientImpl} from '../messaging';
import {DefaultRouter} from '../routing';
import {CommonContainerConst} from './commonContainerConst';

export const commonContainerRegistrations = (container: Container) => {
    container
        .register(CommonContainerConst.fetchService, FetchServiceImpl)
        .singleton();
    container
        .register(CommonContainerConst.router, DefaultRouter)
        .singleton();
    container
        .register(CommonContainerConst.messagingClient, MessagingClientImpl)
        .inject(
            CommonContainerConst.fetchService,
            CommonContainerConst.shellApi_appConfig
        )
        .singleton();
    registerServiceClients(container, CommonContainerConst.messagingClient);
};
